// extracted by mini-css-extract-plugin
export default {"form":"styles_form__CxWBK","radio-group-card":"styles_radio-group-card__T33Mf"};